/* istanbul ignore file */

import 'videojs-contrib-ads';

import videojs from 'video.js';
import Player from 'video.js/dist/types/player';

import { AdCuePoint, AdPluginSettings, DEFAULT_STRINGS } from './ad-types';
import { cancelPreroll, initializePreroll } from './preroll';

//#TODO: reenable once midrolls are reimplemented
//import { initializeMidrolls } from './midroll';

export { AdPluginSettings } from './ad-types';

function getAdsPluginOptions() {
  return {
    liveCuePoints: false,
    prerollTimeout: 10000,
    debug: false,
  };
}

/**
 * Plugin function initializing
 * @param settings
 */
export function adPlugin(settings: Partial<AdPluginSettings>) {
  const defaults: AdPluginSettings = {
    adsProvider: {
      cuePoints: () => Promise.resolve([]),
      getAd: () => Promise.resolve(undefined),
      getExpectedLiveStreamLength: () => 0,
    },
    strings: DEFAULT_STRINGS,
    minIntervalBetweenAds: 1,
  };

  let mergedSettings: AdPluginSettings = videojs.mergeOptions(
    defaults,
    settings
  );
  if (settings.adsProvider?.adsSettings) {
    mergedSettings = videojs.mergeOptions(
      mergedSettings,
      settings.adsProvider.adsSettings
    );
  }
  // @ts-ignore
  const player = this as videojs.Player;

  // Initialize contrib-ads plugin
  // @ts-ignore
  player.ads(getAdsPluginOptions());
  mergedSettings.adsProvider.cuePoints().then((cuePoints) => {
    const midCuePoints = [];
    let prerollInitialized = false;
    for (const f of cuePoints || []) {
      if (f.time === 'START') {
        player.on('contentchanged', () => {
          initializePreroll(player, f, mergedSettings);
        });
        initializePreroll(player, f, mergedSettings);
        prerollInitialized = true;
      } else if (f.time === 'END') {
        // Post roll is requested
      } else {
        midCuePoints.push(f);
      }
    }
    if (!prerollInitialized) {
      cancelPreroll(player, mergedSettings);
    }
    //#TODO: reenabled once midrolls are supported
    //initializeMidrolls(player, mergedSettings, midCuePoints);
  });
}

export function initAdPlugin() {
  videojs.registerPlugin('adPlugin', adPlugin);
}

/**
 * initializes the ad plugin for a specific instance of the player.
 * @param player the player instance to setup
 * @param settings Settings for the ad plugin
 */
export function setupAdPluginForPlayer(
  player: Player,
  settings: Partial<AdPluginSettings>
) {
  console.info('Initiating ad plugin');
  //@ts-ignore
  player.adPlugin(settings);
}
